import { WSIcons } from "../../commonFunctions/iIcons";

export const getMenu: any = (userType: string) => {
  return {
    staticMenu:
      userType === "admin"
        ? [
            {
              id: 1,
              label: "Home",
              icon: WSIcons.Home,
              path: "/home"
            },
            {
              id: 2,
              label: "Masters",
              icon: WSIcons.Masters,
              children: [
                // toda
                {
                  id: 5,
                  label: "Bills",
                  path: "/bill/list"
                },
                {
                    "id": 6,
                    "label": "Users",
                    "path": "/user/list"
                },
                {
                  id: 7,
                  label: "Supplier",
                  path: "/supplier/list"
                },
                //  {
                //     "id": 8,
                //     "label": "Promotions",
                //     "path": "/promotion/list",
                //     "icon": WSIcons.Home,
                // },
              ]
            },

            {
              id: 9,
              label: "Transactions",
              icon: WSIcons.TrendingUp,
              children: [
                {
                  id: 9,
                  label: "Reconciliation",
                  path: "/actions/list"
                },
                {
                  id: 10,
                  label: "Cheque Not Issued",
                  path: "/chequeIssue/actions/list"
                }
              ]
            }

            // {
            //     "id": 13,
            //     "label": "Settings",
            //     "icon": WSIcons.SettingsIcon,
            //     "children": [
            //         {
            //             "id": 14,
            //             "label": "Organization",
            //             "path": "/organization/view"
            //         },
            //         {
            //             "id": 15,
            //             "label": "Change Password",
            //             "path": "/changepassword"
            //         },

            //     ]
            // },
          ]
        : [
            {
              id: 1,
              label: "Home",
              icon: WSIcons.Home,
              path: "/home"
            },

            {
              id: 8,
              label: "Leave",
              icon: WSIcons.PersonOffIcon,
              children: [
                {
                  id: 9,
                  label: "Leave Request",
                  path: "/leave"
                }
              ]
            },
            {
              id: 16,
              label: "Change Password",
              icon: WSIcons.TrendingUp,
              path: "/changepassword"
            },
            {
              id: 17,
              label: "Holiday",
              icon: WSIcons.HolidayVillageIcon,
              path: "/holiday"
            }
          ]
  };
};
